import React, { useEffect, useState } from 'react';
import StatsCard from '../StatsCard';
import {
  IconUsers,
  IconUserPlus,
  IconBuilding,
  IconActivity,
} from '@tabler/icons-react';
import userAndOrganizationActivityAnalyticService from '../../../services/user-and-organization-activity-analytics.service';

const UserOrganizationStatsCards = () => {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await userAndOrganizationActivityAnalyticService.getUserAndOrganizationStats();
        setStatsData(data);
      } catch (err) {
        console.error('Error fetching stats:', err);
        setError('Failed to load statistics.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (error) {
    return (
      <div className="col-span-full">
        <div className="text-red-600">{error}</div>
      </div>
    );
  }

  const {
    total_users: totalUsers,
    new_users_last_7_days_count: newUsersThisWeek,
    total_registered_organizations: totalOrganizations,
    new_organizations_this_week: newOrganizationsThisWeek,
  } = statsData ?? {};

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
      <StatsCard
        title="Total Users"
        value={totalUsers ?? '-'}
        icon={<IconUsers size={24} />}
        color="primary"
        loading={loading}
      />
      <StatsCard
        title="New Users This Week"
        value={newUsersThisWeek ?? '-'}
        icon={<IconUserPlus size={24} />}
        color="success"
        loading={loading}
      />
      <StatsCard
        title="Total Organizations"
        value={totalOrganizations ?? '-'}
        icon={<IconBuilding size={24} />}
        color="info"
        loading={loading}
      />
      <StatsCard
        title="New Organizations This Week"
        value={newOrganizationsThisWeek ?? '-'}
        icon={<IconActivity size={24} />}
        color="warning"
        loading={loading}
      />
    </div>
  );
};

export default UserOrganizationStatsCards;
